import {from} from "linq-to-typescript";
import LocaleInfo from "./constants/LocaleInfo";
import {defaultLocalCode, defaultLocale} from "./defaults";
import {isBlank, isCapitalLetter} from "../../helpers/stringHelper";
import {isArrayHaveItem, reverseForeach} from "../../helpers/listHelper";
import {LanguageType, LocaleType} from "./intertace";
import LanguageList from "./constants/LanguageList";
import api from "../../services/api";
import {apiUrl} from "../../services";
import {SendNotificationError} from "../../helpers/notificationHelper";
import {GetMessage} from "../../helpers/errorHelper";


export  const translateMultiWordServiceUrl = apiUrl.yonetim.dil + "getStrings";
export  const translateServiceUrl = apiUrl.yonetim.dil + "getString/";
export const getLocaleInfoFromLocal = () => {
    return from(LocaleInfo).where(s => {
        return s.locale === (localStorage.getItem('locale') ?? defaultLocalCode)
    }).firstOrDefault() ?? defaultLocale;
};
export const getLocaleFromLocal = () :LocaleType=> {
    return (localStorage.getItem('locale') ?? defaultLocalCode) as LocaleType;
};
export const setLocaleToLocal =(locale:LocaleType)=>{
    localStorage.setItem('locale', locale);
}

export  const getLocaleHash = async (lang:string)=>{

    try {
        const response = await api.get(apiUrl.yonetim.dil + "getHash/"  + lang);
        if(response.status === 200){
            return response.data?.value as string ?? undefined;
        }else {
            return undefined;
        }

    }catch (e){
        SendNotificationError(GetMessage(e));
    }
    return  undefined;

}

export const getLocalIpSync = () => {
    const localIp = localStorage.getItem('localIp') ?? "undefined";
    return localIp;
};
export const getPublicIp = async () => {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;

};
export const setLocalIpAsync = () => {
    const rtc = new RTCPeerConnection({ iceServers: [] });
    rtc.createDataChannel("");  // Boş bir data channel yaratılıyor.
    rtc.createOffer().then(offer => rtc.setLocalDescription(offer));

    rtc.onicecandidate = (ice) => {
        if (!ice || !ice.candidate || !ice.candidate.candidate) return;

        getPublicIp().then(ip=>{
            localStorage.setItem('localIp', ice?.candidate?.address + "/" + ip || 'undefined');
            }
        );

    };
};

export const setLocalIpInHeaders = (config: any) => {
    // İlk olarak localStorage'da IP olup olmadığını kontrol edelim.
    let localIp = getLocalIpSync();  // Yerel olarak depolanmış IP varsa çek.

    // Eğer IP bulunmazsa (undefined ya da "undefined"), IP'yi asenkron olarak alıp saklarız.
    if (localIp === "undefined") {
        setLocalIpAsync();
    }

    // IP'yi header'a ekliyoruz.
    config.headers!["localIp"] = localIp;
};
export  const changeLocale=async (localeCode:LocaleType):Promise<boolean>=>{
    try {
        if(!isBlank(localeCode)){
            setLocaleToLocal(localeCode);
            return true;
        }
    }
    catch (e){
        console.log(e);
    }
    return  false;

}
export const getPrefixByLocal = (locale: LocaleType) => {
    if (isBlank(locale)) {
        return "";
    }
    const tags: string[] = locale.split("-");
    if (tags.length === 2) {
        return tags[0];
    } else {
        let findTag = "";
        reverseForeach(tags, (data, index) => {
            if (isCapitalLetter(data)) {
                findTag = tags.splice(0, index).join("-");
                return true;
            } else {
                return false;
            }
        })
        return  findTag;
    }
};
export const getLanguageFromLocaleCode = (localeCode: LocaleType):LanguageType|undefined => {
    if (isBlank(localeCode)) {
        return undefined;
    }
    const parts = localeCode.split("-");

    const lang = parts[0];
    const script = parts.length >= 2 && /^[A-Z][a-z]{3}$/.test(parts[1]) ? parts[1] : null;
    //const region = parts.length >= 2 ? parts[parts.length - 1] : null;

    // Spesifik kurallar:
    const specialLangsWithScript = ["zh", "az", "uz", "pa", "ks", "ff", "vai", "shi", "yue"];

    if (script && specialLangsWithScript.includes(lang)) {
        return `${lang}-${script}` as  LanguageType;
    }

    return lang as LanguageType;
};
export const getLanguageNameByLanguageCode = (languageCode: string):string => {
    const name = LanguageList[languageCode];
   return  name !== undefined ? name : "";
};
export const getLanguageCodes = () => {
    return from(LocaleInfo).select(s => s.locale).toArray();
};

export const onNotFoundWords = async (words: string[]): Promise<{ [key: string]: string }> => {
    let resultTranslatedWord: { [key: string]: string } = {};
    try {
        if (!isArrayHaveItem(words)) {
            return resultTranslatedWord;
        }

        const value = await api.post(translateMultiWordServiceUrl, words);
        if (value.status === 200) {

            (value?.data?.value as string[]).forEach((translateWord, index) => {
                if (!(isBlank(translateWord) || translateWord.startsWith("#"))) {
                    resultTranslatedWord[words[index]] = translateWord;
                } else {
                    resultTranslatedWord[words[index]] = "#" + words[index] + "#";
                }
            })
            return resultTranslatedWord;
        } else {

            (words as string[]).forEach((word, _) => {
                if (!(isBlank(word) || word.startsWith("#"))) {
                    resultTranslatedWord[word] = word;
                } else {
                    resultTranslatedWord[word] = "#" + word + "#";
                }
            })

        }
    } catch (e) {
        console.log(e);
    }

    return resultTranslatedWord;

};
export const onNotFoundWord = async (word: string): Promise<string> => {
    let resultTranslatedWord: string = "";
    try {
                const value = await api.get(translateServiceUrl + word);
        if (value.status === 200) {
            return value?.data?.value as string;
        } else {
                if (!(isBlank(word) || word.startsWith("#"))) {
                    resultTranslatedWord = word;
                } else {
                    resultTranslatedWord = "#" + word + "#";
                }
        }
    } catch (e) {
        console.log(e);
    }

    return resultTranslatedWord;

};